import { render, staticRenderFns } from "./EditPagePrefData.vue?vue&type=template&id=42ed7833"
import script from "./EditPagePrefData.vue?vue&type=script&lang=js"
export * from "./EditPagePrefData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports